import { z } from "zod";

export const LiPeopleEntrySchema = z.object({
	id: z.number(),
	liPeopleId: z.number(),
	url: z.string(),
});

export type LiPeopleEntry = z.infer<typeof LiPeopleEntrySchema>;
